import { OnboardingForm } from '@/store';
import { DesignationOption } from '@/types';

export const getDesignationYearOptions = () => {
  const currentYear = new Date().getFullYear();

  return {
    [currentYear]: currentYear,
    [currentYear - 1]: currentYear - 1,
    [currentYear - 2]: currentYear - 2,
    [currentYear - 3]: `${currentYear - 3} or before`,
  };
};

export const getDisclaimerText = (
  form: OnboardingForm,
  disclaimerDesignationOptions: DesignationOption[] = [],
) => {
  const { designations } = form;

  return disclaimerDesignationOptions
    ?.filter(
      disclaimer =>
        !!designations?.[disclaimer.countryCode]?.[disclaimer.designation],
    )
    .map(({ disclaimer }) => disclaimer as string);
};
